import React from "react";
import { withRouter } from "react-router-dom";

import "./styles.scss";

class Donations extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    renderDonationsBar() {
        return (
            <div className="DonationsBarWrapper">
                <div className="DonationsBar">
                    <div className="el"></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="DonationsMainWrapper">
                <h1>We are not quite there yet</h1>
                <h2>Help us get there by delegating with us</h2>
                <p>
                    To be able to start making donations we first to achieve the bare minimum of Cardano staked to be able to mint blocks. This minimum will be
                    around 500k of staked cardano to our pool.
                </p>
                {this.renderDonationsBar()}
                <p>
                    Nonetheless, while we all wait to reach the goal, Phase 2 of the project will start and we will be focusing on building the tools and
                    showing you the experience that can help you
                </p>
            </div>
        );
    }
}

export default withRouter(Donations);
